import { createStore, applyMiddleware, combineReducers, compose } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { polyglotReducer } from 'redux-polyglot'
import { createEpicMiddleware } from 'redux-observable'
import history from '../hashHistory'
import epics from './epics'
import * as api from '../api/planet'
import application from './reducers/application.ts'
import checkout from './reducers/checkout.ts'
import context from './reducers/context.ts'
import errors from './reducers/errors.ts'
import filters from './reducers/filters.ts'
import fromLocalStorage from './reducers/fromLocalStorage.ts'
import member from './reducers/member.ts'
import pricer from './reducers/pricer.ts'
import resources from './reducers/resources.ts'
import lastViewedProducts from './reducers/lastViewedProducts.ts'
import sentryMiddleware from './sentryMiddleware'

// export type State = {
//   +application: any,
//   +context: any,
//   +errors: any,
//   +filters: any,
//   +fromLocalStorage: any,
//   +resources: any,
//   +lastViewedProducts: any,
//   +member: any,
//   +pricer: any,
//   +checkout: any,
//   +polyglot: {},
//   +router: { +location: { pathname: string, search: string }},
//   [any]: empty
// }
// export type ActionType = string
// export type Action = any // need to be fixed with typescript
// export type ActionCreator<A:Action> = (...any) => A
// export type GetState = () => State
// export type Store = { getState: GetState }
// export type ActionsObservable = Observable<Action>
// export type Epic = (ActionsObservable, State) => ActionsObservable
// export type EpicWithInjection = (ActionsObservable, State, { api?: any }) => ActionsObservable
// export type Selector<T> = State => T
// export type Reducer<S> = (S, Action) => S

const reducer = combineReducers({
  application,
  checkout,
  context,
  errors,
  filters,
  fromLocalStorage,
  lastViewedProducts,
  member,
  polyglot: polyglotReducer,
  pricer,
  resources,
  router: connectRouter(history)
})

const middlewares = __RAVEN__ ? [sentryMiddleware] : []
const epicMiddleware = createEpicMiddleware({
  dependencies: { api }
})

middlewares.push(
  epicMiddleware,
  routerMiddleware(history)
)

const storeCreator = (initialState) => createStore(
  reducer,
  initialState,
  compose(
    applyMiddleware(...middlewares),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
  )
)

const store = storeCreator()

epicMiddleware.run(epics)

export { store, storeCreator }
